export default __webpack_public_path__ + "static/media/app_3.455ef0ea.png";